// Permissions, same names the backend stores. Users and checks use `name`;
// frontend checks are UX only, the backend enforces access.
export const Permission = {
  Role: {
    List: { id: 1, name: "Role List" },
    Add: { id: 2, name: "Role Add" },
    Edit: { id: 3, name: "Role Edit" },
    Delete: { id: 4, name: "Role Delete" },
  },
  Dashboard: {
    TotalRegistration: { id: 5, name: "Dashboard Total Registration" },
    ReferralActivity: { id: 6, name: "Dashboard Referral Activity" },
    TotalFunds: { id: 7, name: "Dashboard Total Funds" },
    Withdrawal: { id: 8, name: "Dashboard Withdrawal" },
    Graph: { id: 9, name: "Dashboard Graph" },
  },
  AppSetup: {
    List: { id: 10, name: "App Setup List" },
    Edit: { id: 11, name: "App Setup Edit" },
    StatusChange: { id: 12, name: "App Setup Status Change" },
  },
  Calendar: {
    List: { id: 13, name: "Calendar" },
  },
  PnlClient: {
    List: { id: 14, name: "Pnl Client List" },
    Add: { id: 15, name: "Pnl Client Add" },
    Download: { id: 16, name: "Pnl Client Download" },
  },
  PnlTransaction: {
    List: { id: 17, name: "Pnl Transaction List" },
    Add: { id: 18, name: "Pnl Transaction Add" },
    Download: { id: 19, name: "Pnl Transaction Download" },
  },
  FAQ: {
    List: { id: 20, name: "FAQ List" },
    Add: { id: 21, name: "FAQ Add" },
    Edit: { id: 22, name: "FAQ Edit" },
    Delete: { id: 23, name: "FAQ Delete" },
  },
  Investor: {
    List: { id: 24, name: "Investor List" },
    BankAccountDetails: { id: 25, name: "Investor Bank Account Details" },
    KYCDetails: { id: 26, name: "Investor KYC Details" },
    AddAmount: { id: 27, name: "Investor Add Amount" },
    Download: { id: 28, name: "Investor Download" },
    Edit: { id: 60, name: "Edit Investor" },
  },
  InvestorLedger: {
    List: { id: 29, name: "Investor Ledger List" },
    Download: { id: 30, name: "Investor Ledger Download" },
  },
  Reports: {
    // Matches the previous admin behaviour (the Reports menu followed the
    // investor ledger permission). The backend route uses "Report List".
    List: { id: 29, name: "Investor Ledger List" },
    Download: { id: 30, name: "Investor Ledger Download" },
  },
  AppOperations: {
    List: { id: 31, name: "App Operations List" },
    Add: { id: 32, name: "App Operations Add" },
    Download: { id: 33, name: "App Operations Download" },
    Delete: { id: 34, name: "App Operations Delete" },
  },
  InwardPayment: {
    InvestorList: { id: 35, name: "Inward Payment Investor List" },
    ReportList: { id: 36, name: "Inward Payment Report List" },
    Add: { id: 37, name: "Inward Payment Add" },
    Delete: { id: 38, name: "Inward Payment Delete" },
    Download: { id: 39, name: "Inward Payment Download" },
  },
  OutwardPayment: {
    UsersList: { id: 40, name: "Outward Payment Users List" },
    ReportList: { id: 41, name: "Outward Payment Report List" },
    UsersDownload: { id: 42, name: "Outward Payment Users Download" },
    ReportDownload: { id: 43, name: "Outward Payment Report Download" },
    Submit: { id: 44, name: "Outward Payment Submit" },
    Edit: { id: 45, name: "Outward Payment Edit" },
  },
  TransferPayment: {
    List: { id: 46, name: "Transfer Payment List" },
    Download: { id: 47, name: "Transfer Payment Download" },
  },
  Notification: {
    List: { id: 48, name: "Notification List" },
    Add: { id: 49, name: "Notification Add" },
    Download: { id: 50, name: "Notification Download" },
  },
  PNLClientTransaction: {
    List: { id: 51, name: "PNL Client Transaction List" },
    Download: { id: 52, name: "PNL Client Transaction Download" },
  },
  Employee: {
    List: { id: 53, name: "Employee List" },
    Add: { id: 54, name: "Employee Add" },
    Edit: { id: 55, name: "Employee Edit" },
    Delete: { id: 56, name: "Employee Delete" },
  },
  RateUs: {
    List: { id: 57, name: "Rate Us List" },
    Download: { id: 58, name: "Rate Us Download" },
  },
  Chats: {
    List: { id: 61, name: "Chats" },
  },
  Subject: {
    List: { id: 91, name: "Subject List" },
    Add: { id: 92, name: "Subject Add" },
    Edit: { id: 93, name: "Subject Edit" },
    Delete: { id: 94, name: "Subject Delete" },
  },
  Tickets: {
    List: { id: 101, name: "Tickets List" },
    Action: { id: 102, name: "Tickets Action" },
  },
  Network: {
    List: { id: 111, name: "Network List" },
    Add: { id: 112, name: "Network Add" },
    Edit: { id: 113, name: "Network Edit" },
    Delete: { id: 114, name: "Network Delete" },
  },
  AboutBlueChart: {
    List: { id: 121, name: "About BlueChart List" },
    Add: { id: 122, name: "About BlueChart Add" },
    Edit: { id: 123, name: "About BlueChart Edit" },
    Delete: { id: 124, name: "About BlueChart Delete" },
  },
  TermsAndCondition: {
    List: { id: 131, name: "Terms And Condition List" },
    Add: { id: 132, name: "Terms And Condition Add" },
    Edit: { id: 133, name: "Terms And Condition Edit" },
    Delete: { id: 134, name: "Terms And Condition Delete" },
  },
  PrivacyPolicy: {
    List: { id: 141, name: "Privacy Policy List" },
    Add: { id: 142, name: "Privacy Policy Add" },
    Edit: { id: 143, name: "Privacy Policy Edit" },
    Delete: { id: 144, name: "Privacy Policy Delete" },
  },
  OurMissions: {
    List: { id: 151, name: "Our Missions List" },
    Add: { id: 152, name: "Our Missions Add" },
    Edit: { id: 153, name: "Our Missions Edit" },
    Delete: { id: 154, name: "Our Missions Delete" },
  },
  LiquidityProviders: {
    List: { id: 161, name: "Liquidity Providers List" },
    Add: { id: 162, name: "Liquidity Providers Add" },
    Edit: { id: 163, name: "Liquidity Providers Edit" },
    Delete: { id: 164, name: "Liquidity Providers Delete" },
  },
  Awards: {
    List: { id: 171, name: "Awards List" },
    Add: { id: 172, name: "Awards Add" },
    Edit: { id: 173, name: "Awards Edit" },
    Delete: { id: 174, name: "Awards Delete" },
  },
  OurLocations: {
    List: { id: 181, name: "Our Locations List" },
    Add: { id: 182, name: "Our Locations Add" },
    Edit: { id: 183, name: "Our Locations Edit" },
    Delete: { id: 184, name: "Our Locations Delete" },
  },
  BankDetail: {
    List: { id: 191, name: "Bank Detail List" },
    Add: { id: 192, name: "Bank Detail Add" },
    Edit: { id: 193, name: "Bank Detail Edit" },
    Delete: { id: 194, name: "Bank Detail Delete" },
  },
  Licence: {
    List: { id: 201, name: "Licence List" },
    Edit: { id: 202, name: "Licence Edit" },
  },
  Country: {
    List: { id: 211, name: "Country List" },
    Add: { id: 212, name: "Country Add" },
    Edit: { id: 213, name: "Country Edit" },
    Delete: { id: 214, name: "Country Delete" },
  },
  State: {
    List: { id: 221, name: "State List" },
    Add: { id: 222, name: "State Add" },
    Edit: { id: 223, name: "State Edit" },
    Delete: { id: 224, name: "State Delete" },
  },
  City: {
    List: { id: 231, name: "City List" },
    Add: { id: 232, name: "City Add" },
    Edit: { id: 233, name: "City Edit" },
    Delete: { id: 234, name: "City Delete" },
  },
  Strategy: {
    List: { id: 251, name: "Strategy List" },
    Edit: { id: 252, name: "Strategy Edit" },
  },
};
